import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/system';
import { FULL_WIDTH_ROUTES } from 'constants/routes';
import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { IProps } from 'types/common';

interface IMainLayoutProps extends IProps {
	sx: SxProps<Theme>;
}

const MainLayout: FC<IMainLayoutProps> = ({ children, sx }) => {
	const { pathname } = useLocation();
	const fullWidth = FULL_WIDTH_ROUTES.some((route) => pathname.includes(route));

	return (
		<Box
			component="main"
			id="app-container-body"
			role="main"
			display="flex"
			flexGrow={1}
			flexDirection="column"
			borderLeft={1}
			position="relative"
			overflow="auto"
			sx={{
				borderLeftWidth: 1,
				borderColor: 'divider',
				...sx
			}}
			px={{
				xs: fullWidth ? 0 : 2,
				sm: fullWidth ? 0 : 4,
				md: fullWidth ? 0 : 4,
				lg: fullWidth ? 0 : 6,
				xl: fullWidth ? 0 : 8
			}}
			pb={{
				xs: 5,
				sm: 0
			}}
		>
			{children}
		</Box>
	);
};

export default MainLayout;
